<template lang="html">

  <div data="movilidad" class="cv-part">

    <h2 class="title" @click="openedit" :edit="showedit">Movilidad</h2>

    <p :title="info.disponibilidadViajar | sino">
      Disponibilidad para viajar:
      <span :active="(info.disponibilidadViajar)" :title="info.disponibilidadViajar | sino" class="fake-check">{{info.disponibilidadViajar | sino}}</span>
    </p>
    <p :title="info.residencia | sino">
      Movilidad nacional:
      <span :active="(info.residencia)" :title="info.residencia | sino" class="fake-check">{{info.residencia | sino}}</span>
    </p>
    <p :title="info.extranjero | sino">
      Movilidad internacional:
      <span :active="(info.extranjero)" :title="info.extranjero | sino" class="fake-check">{{info.extranjero | sino}}</span>
    </p>
    <p :title="info.carnet | sino">
      Permiso de conducir:
      <span :active="(info.carnet)" :title="info.carnet | sino" class="fake-check">{{info.carnet | sino}}</span>
    </p>
    <p :title="info.coche | sino">
      Vehículo propio:
      <span :active="(info.coche)" :title="info.coche | sino" class="fake-check">{{info.coche | sino}}</span>
    </p>



    <div class="cover-popup row-center" v-if="showedit">
      <div class="popup">
        <a class="close" @click="showedit = false">✕</a>
        <h2 class="title-pop">Editar movilidad</h2>

        <div class="toggle-checkbox" :edit="showedit">
          <input type="checkbox" id="disponibilidadViajar" v-model="editdata.disponibilidadViajar">
          <label for="disponibilidadViajar">Disponibilidad para viajar</label>
        </div>

        <div class="toggle-checkbox" :edit="showedit">
          <input type="checkbox" id="movilidadnacional" v-model="editdata.residencia">
          <label for="movilidadnacional">Movilidad nacional</label>
        </div>

        <div class="toggle-checkbox" :edit="showedit">
          <input type="checkbox" id="movilidadinternacional" v-model="editdata.extranjero">
          <label for="movilidadinternacional">Movilidad internacional</label>
        </div>

        <div class="toggle-checkbox" :edit="showedit">
          <input type="checkbox" id="permisoconducir" v-model="editdata.carnet">
          <label for="permisoconducir">Permiso de conducir</label>
        </div>

        <div class="toggle-checkbox" :edit="showedit">
          <input type="checkbox" id="vehiculopropio" v-model="editdata.coche">
          <label for="vehiculopropio">Vehiculo propio</label>
        </div>

        <button class="btn" @click="senddata">Guardar</button>
      </div>
    </div>

  </div>


</template>

<script lang="js">

  import {mapActions} from 'vuex';

  export default {
    name: 'movilidad',
    props : ['info'],
    mounted(){
      for(let i in this.editdata){
        this.editdata[i] = this.info[i];
      }
    },
    data() {
      return {
        showedit: false,
        editdata : {
          disponibilidadViajar : '',
          residencia : '',
          extranjero : '',
          carnet : '',
          coche : ''
        }
      }
    },
    filters : {
      sino(value){
        return (value) ? 'Sí' : 'No';
      }
    },
    methods:{
      ...mapActions(['editMovilidad','canEditCv']),
      openedit(){
        this.canEditCv().then(r =>{
          (r) ? this.showedit = true : '';
        });
      },
      senddata(){
        this.editMovilidad(this.editdata).then(r => {
          this.showedit = false;
        })
      }
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/movilidad.vue